export const loadGoogleScripts = () => {
  // Delay loading to ensure it doesn't block initial render
  setTimeout(() => {
    // Load Google Analytics (gtag.js)
    const gtagScript = document.createElement('script');
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-0SQQ6EFNVB';
    gtagScript.async = true;
    document.head.appendChild(gtagScript);

    gtagScript.onload = () => {
      const gtagInlineScript = document.createElement('script');
      gtagInlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-0SQQ6EFNVB');
      `;
      document.head.appendChild(gtagInlineScript);
    };

    // Load Google AdSense
    const adsenseScript = document.createElement('script');
    adsenseScript.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8593988932903181';
    adsenseScript.async = true;
    adsenseScript.crossOrigin = 'anonymous';
    document.head.appendChild(adsenseScript);

  }, 2000); // 2-second delay
}; 